module.exports = {
  getCars:
    "http://api.bart.gov/api/bsa.aspx?cmd=count&key=MW9S-E7SL-26DU-VV8V&json=y",
  getAdvisories:
    "http://api.bart.gov/api/bsa.aspx?cmd=bsa&key=MW9S-E7SL-26DU-VV8V&json=y",
  getElevators:
    "http://api.bart.gov/api/bsa.aspx?cmd=elev&key=MW9S-E7SL-26DU-VV8V&json=y",
  getStationList:
    "http://api.bart.gov/api/stn.aspx?cmd=stns&key=MW9S-E7SL-26DU-VV8V&json=y",
  getStationInfo:
    "http://api.bart.gov/api/stn.aspx?cmd=stninfo&key=MW9S-E7SL-26DU-VV8V&json=y&orig=",
  getDepartureEstimates:
    "http://api.bart.gov/api/etd.aspx?cmd=etd&key=MW9S-E7SL-26DU-VV8V&json=y&orig=",
  getStationAccess:
    "http://api.bart.gov/api/stn.aspx?cmd=stnaccess&&key=MW9S-E7SL-26DU-VV8V&l=1&json=y&orig="
};
